import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { emailPageTexts } from "../lib/emailPagesI18n";

export default function EmailError() {
  const { search } = useLocation();
  const { lang, tx } = emailPageTexts(search);
  return (
    <div className="min-h-screen flex items-center justify-center pt-28 pb-24 px-6" data-testid="email-error-page" lang={lang}>
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}
        className="max-w-2xl text-center"
      >
        <div className="w-20 h-20 mx-auto mb-8 border border-gold/50 flex items-center justify-center">
          <AlertTriangle className="text-gold" size={34} strokeWidth={1.5} />
        </div>
        <p className="text-xs uppercase tracking-luxe text-gold mb-6">{tx.errorKicker}</p>
        <h1 className="font-serif text-4xl md:text-5xl text-white leading-tight mb-6" data-testid="email-error-title">
          {tx.errorTitle}
        </h1>
        <p className="text-white/60 font-light text-lg leading-relaxed" data-testid="email-error-body">
          {tx.errorBody}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/diagnostic-inaugural" data-testid="email-error-retry"
            className="bg-gold text-brand-ink hover:bg-brand-gold-hover transition-colors px-8 py-4 text-xs uppercase tracking-[0.15em] font-semibold inline-block">
            {tx.retry}
          </Link>
          <Link to="/" data-testid="email-error-home"
            className="border border-white/20 text-white hover:border-gold hover:text-gold transition-colors px-8 py-4 text-xs uppercase tracking-[0.15em] inline-block">
            {tx.home}
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
